import { useState, useEffect, useRef } from 'react';
import budapest from './budapest.png';
import './App.css';

const TARGET = new Date('2026-04-22T00:01:00+03:00').getTime();
const TRIP_TARGET = new Date('2026-06-19T18:00:00+02:00').getTime();
function pad(n) { return String(n).padStart(2, '0'); }
function getTimeLeft() {
  const diff = TARGET - Date.now();
  if (diff <= 0) return null;
  return {
    days:  Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins:  Math.floor((diff % 3600000) / 60000),
    secs:  Math.floor((diff % 60000) / 1000),
  };
}
function getTripTimeLeft() {
  const diff = TRIP_TARGET - Date.now();
  if (diff <= 0) return null;
  return {
    days:  Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins:  Math.floor((diff % 3600000) / 60000),
    secs:  Math.floor((diff % 60000) / 1000),
  };
}

function Confetti() {
  const colors = ['#FAC775','#F0997B','#AFA9EC','#9FE1CB','#F4C0D1','#ffffff','#EF9F27'];
  const dots = useRef(Array.from({ length: 120 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    color: colors[Math.floor(Math.random() * colors.length)],
    delay: Math.random() * 3.5,
    dur: 3 + Math.random() * 3,
    size: 5 + Math.random() * 6,
    round: Math.random() > 0.5,
  }))).current;
  return (
    <div className="confetti-layer">
      {dots.map(d => (
        <div key={d.id} className="cdot" style={{
          left: d.left + 'vw', background: d.color,
          animationDelay: d.delay + 's', animationDuration: d.dur + 's',
          width: d.size, height: d.size,
          borderRadius: d.round ? '50%' : '2px',
        }} />
      ))}
    </div>
  );
}

function Plane({ onClick }) {
  return (
    <div className="plane-layer">
      <div className="plane-fly" onClick={onClick}>
        <div className="plane-trail" />
        <svg viewBox="0 0 24 24" className="plane-svg" width="30" height="30" aria-label="plane">
          <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 1 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 18.5V13.5L21 16z" fill="currentColor"/>
        </svg>
      </div>
    </div>
  );
}

function SteamPuffs() {
  const puffs = useRef(Array.from({ length: 14 }, (_, i) => ({
    id: i, left: Math.random() * 100,
    size: 40 + Math.random() * 70,
    dur: 6 + Math.random() * 8,
    delay: Math.random() * 8,
  }))).current;
  return (
    <div className="steam-layer">
      {puffs.map(p => (
        <div key={p.id} className="steam-puff" style={{
          left: p.left + '%', width: p.size, height: p.size,
          animationDuration: p.dur + 's', animationDelay: p.delay + 's',
        }} />
      ))}
    </div>
  );
}

export default function App() {
  const [time, setTime] = useState(getTimeLeft());
  const [tripTime, setTripTime] = useState(getTripTimeLeft());
  const [revealed, setRevealed] = useState(!getTimeLeft());
  const [confettiKey, setConfettiKey] = useState(0);
  const cardRef = useRef(null);

  const doReveal = () => { setRevealed(true); setConfettiKey(k => k + 1); };

  useEffect(() => {
    const t = setInterval(() => {
      const tl = getTimeLeft();
      if (!tl && !revealed) { setRevealed(true); setConfettiKey(k => k + 1); }
      setTime(tl);
      setTripTime(getTripTimeLeft());
    }, 1000);
    return () => clearInterval(t);
  }, [revealed]);

  useEffect(() => {
    if (!revealed) return;
    const loop = setInterval(() => setConfettiKey(k => k + 1), 5500);
    return () => clearInterval(loop);
  }, [revealed]);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const r = card.getBoundingClientRect();
    const rx = ((e.clientY - r.top - r.height / 2) / (r.height / 2)) * -6;
    const ry = ((e.clientX - r.left - r.width / 2) / (r.width / 2)) * 6;
    card.style.animation = 'none';
    card.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleMouseLeave = () => {
    if (!cardRef.current) return;
    cardRef.current.style.animation = '';
    cardRef.current.style.transform = '';
  };

  return (
    <div className={`scene ${revealed ? 'revealed' : ''}`}>
      <div className="bg" style={{ backgroundImage: `url(${budapest})` }} />
      <div className="overlay" />
      <SteamPuffs />
      {revealed && <Plane onClick={() => setConfettiKey(k => k + 1)} />}
      {revealed && <Confetti key={confettiKey} />}

      {!revealed ? (
        <div className="countdown-view" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
          <div className="card" ref={cardRef}>
            <div className="ornament">— ✦ —</div>
            <p className="for-label">a surprise for</p>
            <p className="axxa">Axxa</p>
            <div className="divider" style={{ marginTop: '1.4rem' }} />
            <p className="mystery">something magical<br />is waiting for you…</p>
            <div className="timer">
              {[['days', time?.days], ['hours', time?.hours], ['min', time?.mins], ['sec', time?.secs]].map(([lbl, val], i) => (
                <div key={lbl} style={{ display:'flex', alignItems:'flex-start', gap:'1rem' }}>
                  {i > 0 && <span className="sep">:</span>}
                  <div className="unit">
                    <span className="num">{pad(val ?? 0)}</span>
                    <span className="lbl">{lbl}</span>
                  </div>
                </div>
              ))}
            </div>
            <p className="hint">your surprise is almost here</p>
            <button type="button" className="skip-link" onClick={doReveal}>skip →</button>
          </div>
        </div>
      ) : (
        <div className="reveal-view">
          <div className="ornament">— ✦ —</div>
          <p className="for-label">happy 30th birthday</p>
          <p className="axxa glow">Axxa</p>
          <div className="divider" />
          <span className="spa-badge">girl's trip getaway</span>
          <p className="pack-lead">pack your bags…</p>
          <p className="reveal-dest">We're going<br />to Budapest!</p>
          <div className="divider" style={{ marginTop: '0.7rem' }} />
          <p className="reveal-sub">thermal baths, golden domes<br />&amp; the best girls' trip of your life</p>
          {tripTime && (
            <div className="trip-block">
              <p className="trip-date">Fri · 19 Jun 2026</p>
              <p className="trip-time">18:00 · Budapest</p>
              <div className="trip-countdown">
                <span className="tcd-part"><span className="tcd-n">{tripTime.days}</span><span className="tcd-l">d</span></span>
                <span className="tcd-dot">·</span>
                <span className="tcd-part"><span className="tcd-n">{pad(tripTime.hours)}</span><span className="tcd-l">h</span></span>
                <span className="tcd-dot">·</span>
                <span className="tcd-part"><span className="tcd-n">{pad(tripTime.mins)}</span><span className="tcd-l">m</span></span>
                <span className="tcd-dot">·</span>
                <span className="tcd-part"><span className="tcd-n">{pad(tripTime.secs)}</span><span className="tcd-l">s</span></span>
              </div>
            </div>
          )}
          <p className="hint" style={{ marginTop: '1rem' }}>it's time ✦</p>
        </div>
      )}
    </div>
  );
}
